export default __webpack_public_path__ + "static/media/box2-ar.2c3be6cb.svg";